import Dropdown from "react-bootstrap/Dropdown";
import Topshopslider from "./small/Topshopslider";
import TopSellers from "./small/topSellers";
import Footer from "./small/Footer";
import PhysicalItems from "./small/physical-items";
import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";
import TopRaffles from "./small/topRaffles";

const Home = () => {
  const topRaffles = [
    {
      firstImg: "../../../assets/images/topraffle/img1.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
    {
      firstImg: "../../../assets/images/topraffle/main2.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
    {
      firstImg: "../../../assets/images/topraffle/main3.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
    {
      firstImg: "../../../assets/images/topraffle/main4.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
    {
      firstImg: "../../../assets/images/topraffle/main5.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
    {
      firstImg: "../../../assets/images/topraffle/main6.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
    {
      firstImg: "../../../assets/images/topraffle/main7.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
    {
      firstImg: "../../../assets/images/topraffle/main8.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
  ];
  const popularCollection = [
    {
      profImg: "../../../assets/images/prof-collection.png",
      collectionTitle: "Creative Art collection",
      createdBy: "Jena Hawk",
      hearts: "1.2k",
      imageOne: "../../assets/images/collection/img1.png",
      imageTwo: "../../assets/images/collection/img2.png",
      imageThree: "../../assets/images/collection/img3.png",
      imageFour: "../../assets/images/collection/img4.png",
    },
    {
      profImg: "../../../assets/images/prof-collection.png",
      collectionTitle: "Creative Art collection",
      createdBy: "Jena Hawk",
      hearts: "1.2k",
      imageOne: "../../assets/images/collection/c21.png",
      imageTwo: "../../assets/images/collection/c22.png",
      imageThree: "../../assets/images/collection/c23.png",
      imageFour: "../../assets/images/collection/c24.png",
    },
    {
      profImg: "../../../assets/images/prof-collection.png",
      collectionTitle: "Creative Art collection",
      createdBy: "Jena Hawk",
      hearts: "1.2k",
      imageOne: "../../assets/images/collection/c31.png",
      imageTwo: "../../assets/images/collection/c32.png",
      imageThree: "../../assets/images/collection/c33.png",
      imageFour: "../../assets/images/collection/c34.png",
    },
  ];

  // const toggleMode = (e) => {
  //   if (e.target.checked === true) {
  //     localStorage.theme = "light";
  //     document.body.classList.add("light");
  //     localStorage.testt = "true";
  //   } else {
  //     localStorage.theme = "dark";
  //     document.body.classList.remove("light");
  //     localStorage.testt = "false";
  //   }
  //   var x = document.getElementById("swticher-label");
  //   if (x.innerHTML === "Dark Mode") {
  //     x.innerHTML = "Light Mode";
  //   } else {
  //     x.innerHTML = "Dark Mode";
  //   }

  // };
  // useEffect(() => {
  //   // console.log(localStorage.testt);
  //   if (localStorage.theme === "light") {
  //     document.body.classList.add("light");
  //     var x = document.getElementById("swticher-label");
  //     x.innerHTML = "Light Mode";
  //     const checkbox = document.getElementById("custom-switch");
  //     checkbox.checked = checkbox.checked;
  //   } else {
  //     document.body.classList.remove("light");
  //   }
  // }, []);

  // useEffect(() => {}, [localStorage.testt]);
  return (
    <>
      {/* 
      <section className="for-toggle">
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <div className="toggle-wrapper">
                <div className="dark-wrapp">
                  <Form>
                    <div className="d-flex align-items-center">
                      <label htmlFor="custom-switch" id="swticher-label">
                        Dark Mode
                      </label>
                      <Form.Check
                        type="switch"
                        id="custom-switch"
                        onChange={(e) => toggleMode(e)}
                      />
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      <section className="hero-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-sm-5">
              <h1 className="first-tit">NFT MARKETPLACE</h1>
              <h2 className="giveyours">Give Your NFT Tokens Utility</h2>
              <p className="banner-txt">
                Sell, Raffle, and Auction physical and digital items to your
                community in your native token.
              </p>
              <button className="explore-btn">Explore</button>
              <Link to="/createnft">
                <button className="create-nft-btn">Create NFT</button>
              </Link>
            </div>

            <div className="col-sm-7 text-end">
              <img
                className="main-banner-img img-fluid"
                src="../../../assets/images/banner-img.png"
              />
            </div>
          </div>
        </div>
      </section>
      <main className="whole-main">
        <section id="top-shops" className="customize-arrows">
          <div className="container">
            <div className="row">
              <div className="col-sm-3">
                <div className="d-flex justify-content-between">
                  <div className="title">
                    <h2 className="main-tite">Top Shop</h2>
                  </div>
                  <div className="drop-filer-r">
                    <Dropdown>
                      <Dropdown.Toggle id="filter-dropdown">
                        Last 15 minutes
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item href="#/action-2">
                          Last 1 hour
                        </Dropdown.Item>
                        <Dropdown.Item href="#/action-3">
                          Last 6 hours
                        </Dropdown.Item>
                        <Dropdown.Item href="#/action-3">
                          Last 12 hours
                        </Dropdown.Item>
                        <Dropdown.Item href="#/action-3">
                          Last 24 hours
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 ">
                <Topshopslider />
              </div>
            </div>
          </div>
        </section>
        <section id="top-sellers" className="customize-arrows">
          <div className="container">
            <div className="row">
              <div className="col-sm-3">
                <div className="d-flex d-flex justify-content-between">
                  <div className="title">
                    <h2 className="main-tite">Top Sellers</h2>
                  </div>
                  <div className="drop-filer-r">
                    <Dropdown>
                      <Dropdown.Toggle id="filter-dropdown">
                        Last 15 minutes
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item href="#/action-2">
                          Last 1 hour
                        </Dropdown.Item>
                        <Dropdown.Item href="#/action-3">
                          Last 6 hours
                        </Dropdown.Item>
                        <Dropdown.Item href="#/action-3">
                          Last 12 hours
                        </Dropdown.Item>
                        <Dropdown.Item href="#/action-3">
                          Last 24 hours
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 nopadding">
                <TopSellers />
              </div>
            </div>
          </div>
        </section>

        <section id="top-raffles">
          <div className="container">
            <div className="row">
              <div className="col-sm-3">
                <div className="d-flex justify-content-between">
                  <div className="title">
                    <h2 className="main-tite">Top Raffles</h2>
                  </div>
                  <div className="drop-filer-r">
                    <Dropdown>
                      <Dropdown.Toggle id="filter-dropdown">
                        Last 15 minutes
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item href="#/action-2">
                          Last 1 hour
                        </Dropdown.Item>
                        <Dropdown.Item href="#/action-3">
                          Last 6 hours
                        </Dropdown.Item>
                        <Dropdown.Item href="#/action-3">
                          Last 12 hours
                        </Dropdown.Item>
                        <Dropdown.Item href="#/action-3">
                          Last 24 hours
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="container">
            <TopRaffles ArrayS={topRaffles} />
          </div>
        </section>

        <section id="physcialitems" className="customize-arrows">
          <div className="container">
            <div className="row">
              <div className="col-sm-3">
                <div className="d-flex justify-content-between">
                  <div className="title">
                    <h2 className="main-tite">Physical Items</h2>
                  </div>
                  <div className="drop-filer-r">
                    <Dropdown>
                      <Dropdown.Toggle id="filter-dropdown">
                        Last 15 minutes
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item href="#/action-2">
                          Last 1 hour
                        </Dropdown.Item>
                        <Dropdown.Item href="#/action-3">
                          Last 6 hours
                        </Dropdown.Item>
                        <Dropdown.Item href="#/action-3">
                          Last 12 hours
                        </Dropdown.Item>
                        <Dropdown.Item href="#/action-3">
                          Last 24 hours
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="container">
            <div className="row">
              <PhysicalItems />
            </div>
          </div>
        </section>

        <section id="popularcollection">
          <div className="container">
            <div className="row">
              <div className="col-sm-12">
                <div className="d-flex justify-content-between">
                  <div className="title">
                    <h2 className="main-tite">Popular Collection</h2>
                  </div>

                  <Link className="explore-more-btn" to="/nftcollection">
                    Explore More
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div className="container">
            <div className="row">
              {popularCollection.map((item, index) => {
                return (
                  <div className="col-sm-4" key={index}>
                    <div className="collection-item-wrap">
                      <div className="d-flex align-items-center justify-content-center">
                        <div className="collection-profile-img">
                          <img className="item-img" src={item.profImg} />
                          <div className="ver-icon-wrap">
                            <img
                              className="verified-img pop-collection"
                              src="../../../assets/images/topseller/verified-icon.png"
                            />
                          </div>
                        </div>

                        <div className="text-section-collection">
                          <h3 className="collection-title">
                            {item.collectionTitle}
                          </h3>
                          <h4 className="createdby">
                            Created by <span>{item.createdBy}</span>
                          </h4>
                        </div>

                        <div className="heart-collection d-flex align-items-center">
                          <img
                            className="heartico"
                            src="../../assets/images/icons/heartico.png"
                            alt=""
                          />
                          <h3 className="hearcount">{item.hearts}</h3>
                        </div>
                      </div>

                      <div className="d-flex main-collection-image-section">
                        <div className="firs-img-div">
                          <img
                            className="img-fluid c-img c1image"
                            src={item.imageOne}
                            alt=""
                          />
                        </div>
                        <div className="d-flex align-items-between main-class-ss">
                          <div className="d-flex align-items-start first-flex">
                            <img
                              src={item.imageTwo}
                              alt=""
                              className="img-fluid c-img"
                            />
                            <img
                              src={item.imageThree}
                              alt=""
                              className="img-fluid c-img"
                            />
                          </div>
                          <img
                            src={item.imageFour}
                            alt=""
                            className="img-fluid c-img"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        <section id="recently-sold">
          <div className="container">
            <div className="row">
              <div className="col-sm-3">
                <div className="d-flex justify-content-between">
                  <div className="title">
                    <h2 className="main-tite">Recently Sold</h2>
                  </div>
                  <div className="drop-filer-r"></div>
                </div>
              </div>
            </div>
          </div>

          <div className="container">
            <div className="row">
              {topRaffles.map((item, index) => {
                return (
                  <div
                    className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12 "
                    key={index}
                  >
                    <div className="sold-wrapper">
                      <div className="sold-rec">Sold</div>
                      <div className="top-raffle-single">
                        <img
                          className="top-raffle-single-img"
                          src={item.firstImg}
                        />
                        <div className="d-flex align-items-center top-raffle-first">
                          <img
                            className="top-raffle-prof-imgp"
                            src={item.profImg}
                          />

                          <h3 className="raffle-it">{item.title}</h3>
                        </div>

                        <div className="d-flex align-items-center justify-content-between top-raffle-second">
                          <h3 className="instock">
                            in stock <span>{item.inStock}</span>
                          </h3>
                          <div className="d-flex align-items-center justify-content-between price">
                            <h3 className="price-tit">
                              price:
                              <img
                                className="etheriumico"
                                src="../../../assets/images/topraffle/img4.png"
                              />
                              <span>{item.price}</span>
                            </h3>
                          </div>
                        </div>
                        <div className="forborder-bott"></div>

                        <div className="d-flex align-items-center bottom-items justify-content-between top-raffle-third">
                          <div className="d-flex align-items-center">
                            <img
                              className="top-raffle-prof-imgp"
                              src={item.userImg}
                            />

                            <h3 className="seller-name">{item.userName}</h3>
                          </div>
                          <div>
                            <button className="place-bid">Place bid</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>
        <Footer />
      </main>
    </>
  );
};
export default Home;
